// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { useEffect, useRef, useState } from 'react';

import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Input, { InputProps } from '@cloudscape-design/components/input';
import Link from '@cloudscape-design/components/link';


import SpaceBetween from '@cloudscape-design/components/space-between';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Flashbar, { FlashbarProps } from '@cloudscape-design/components/flashbar';
import { useGlobalState } from '../../../context/GlobalStateContext'
import { Icon } from '@cloudscape-design/components';

export const AdminPasswordPage = () => {
    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { idControl, setIdControl } = useGlobalState();
    const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState();

    const [inputPassword, setInputPassword] = useState('');
    const [inputPassword1, setInputPassword1] = useState('');
    const [inputPassword2, setInputPassword2] = useState('');
    const [isDisabledPassword, setIsDiabledPassword] = useState(false);
    const [isDisabledBtnMod, setIsDisabledBtnMod] = useState(true);
    const [showNewPassword, setShowNewPassword] = useState(false);



    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const inputRef = useRef<HTMLInputElement>(null);
    const [isDisabledBtnNext, setIsDisabledBtnNext] = useState(false);
    const [loadingBtnNext, setLoadingBtnNext] = useState(false);
    const { setLoading } = useGlobalState();
    const [errors, setErrors] = useState<string[]>([]);

    /*
      const onJobNameChangePhone = (event: any) => {
        setJobName(event.detail.value);
        setMessages([]);
      };
      */
    const handleInputPassword: InputProps["onChange"] = (event) => {
        setInputPassword(event.detail.value);
    };
    const handleInputPassword1: InputProps["onChange"] = (event) => {
        setInputPassword1(event.detail.value);
        validatePassword(event.detail.value);
    };
    const handleInputPassword2: InputProps["onChange"] = (event) => {
        setInputPassword2(event.detail.value);
        validatePassword(inputPassword1)

    };

    const [shouldRedirect, setShouldRedirect] = useState(false);
    useEffect(() => {
        if (shouldRedirect && JWT) {
            if (idPropiedad) {
                if (idPropiedad === 0)
                    window.location.hash = '#admin/properties';
                else
                    window.location.hash = '#home';
            }
        }

    }, [shouldRedirect]);


    const handleValidatePassword = async () => {
        setMessages([])
        if (inputPassword.length == 0) {
            setMessages([
                {
                    type: 'error',
                    content: 'Ingrese una contraseña válida',
                    id: 'error-msg',
                },
            ]);
            return
        }
        setLoadingBtnNext(true);
        try {
            
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/admins/mod.pwd',
                    'JWT': JWT,
                    // 
                },
                body: JSON.stringify({
                    idControl: idControl,
                    password: inputPassword,
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);

            }
            const data = await response.json();
            if (data.code == 0) {
                setShowNewPassword(true)
                setIsDiabledPassword(true)
                setIsDisabledBtnNext(true)
                setIsDisabledBtnMod(true)
            } else {
                setInputPassword('')
                setMessages([
                    {
                        type: 'error',
                        content: data.status,
                        id: 'server-error',
                    },
                ]);
            }
        } catch (error: any) {
            setMessages([
                {
                    type: 'error',
                    content: `Error al contactar el servidor: ${error.message}`,
                    id: 'server-error',
                },
            ]);
        } finally {
            setLoadingBtnNext(false);
            setLoading(false);
        }
    }
    const handleValidateNewPasword = async () => {
        if (inputPassword1 == '') {
            setMessages([
                {
                    type: 'error',
                    content: 'Nueva contraseña inválida',
                    id: 'error-msg',
                },
            ]);
            return
        }
        if (inputPassword1 !== inputPassword2) {
            setMessages([
                {
                    type: 'error',
                    content: 'Nueva contraseña y confirmación no coinciden',
                    id: 'error-msg',
                },
            ]);
            return
        }
        setLoadingBtnNext(true);
        try {
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/admins/mod.pwd',
                    'JWT': JWT,
                    // 
                },
                body: JSON.stringify({
                    idControl: idControl,
                    password: inputPassword,
                    newPassword: inputPassword1,
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
                setIsDisabledBtnNext(false)
            }
            const data = await response.json();
            if (data.code == 0) {
                setIsDiabledPassword(false);
                setInputPassword('');
                setIsDisabledBtnNext(false)
                setShowNewPassword(false)
                setMessages([
                    {
                        type: 'success',
                        content: 'Contrseña ha sido modificada',
                        id: 'error-msg',
                    },
                ]);
            } else {
                setMessages([
                    {
                        type: 'error',
                        content: data.status,
                        id: 'server-error',
                    },
                ]);
            }
        } catch (error: any) {
            setMessages([
                {
                    type: 'error',
                    content: `Error al contactar el servidor: ${error.message}`,
                    id: 'server-error',
                },
            ]);
        } finally {
            setLoadingBtnNext(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        setIsDisabledBtnMod(errors.length > 0 || (inputPassword1 !== inputPassword2 && inputPassword1.length > 0))
    }, [errors]);

    const validatePassword = (passwordToCheck: string) => {
        const newErrors: string[] = [];
        if (passwordToCheck.length < 8) {
            newErrors.push('Al menos 8 caracteres');
        }

        if (!/[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?]/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos un símbolo (ej: # $ . ?)');
        }
        if (!/(?=.*[a-z])/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos una letra minúscula');
        }
        if (!/(?=.*[A-Z])/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos una letra mayúscula');
        }
        if (!/(?=.*\d)/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos un número');
        }
        if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?])/.test(passwordToCheck)) {
            //   newErrors.push('Debe incluir una mezcla de letras mayúsculas y minúsculas, números y símbolos');
        }

        setErrors(newErrors);
    }

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const createJob = () => {
        //setPendingJobCreation(true);
        //setTimeout(() => navigate('transcription-job-list'), 1000);
    };

    const handleBtnBack = () => {
        setIsDiabledPassword(false);
        setInputPassword('');
        setIsDisabledBtnNext(false)
        setShowNewPassword(false)
    };

    return (
        <>
            <CustomAppLayout
                breadcrumbs={
                    <BreadcrumbGroup
                        items={[
                            { text: 'Inicio', href: '#home' },
                            { text: 'Administradores', href: '#admin/default' },
                            { text: 'Modificar contraseña', href: '#create-transcription-job' },
                        ]}
                        expandAriaLabel="Show path"
                        ariaLabel="Breadcrumbs"
                    />
                }
                toolsHide={true}
                contentType="form"
                content={
                    <form onSubmit={event => event.preventDefault()}>
                        <Form
                            header={
                                <Header variant="h1">
                                    <Icon name='key' size='medium'></Icon>  Modificar contraseña
                                </Header>
                            }
                        >
                            <SpaceBetween size="xl">
                                <Container header={''}>
                                    <SpaceBetween size="l">
                                        <Flashbar items={messages} />
                                        <FormField
                                            label="Contraseña actual"
                                            constraintText="Indique su actual contraseña para validacion.">
                                            <SpaceBetween direction="horizontal" size="xs">
                                                <Input
                                                    controlId='infoPassword'
                                                    value={inputPassword}
                                                    disabled={isDisabledPassword}
                                                    onChange={handleInputPassword}
                                                    ref={inputRef}
                                                    autoComplete=""
                                                    type='password'
                                                />
                                                <Button onClick={handleValidatePassword} disabled={isDisabledBtnNext} variant="primary" loading={loadingBtnNext} >Siguiente</Button>

                                            </SpaceBetween>
                                        </FormField>

                                        {showNewPassword && (
                                            <FormField label="Nueva contraseña"
                                                info={
                                                    (<Link variant="info" onClick={handleBtnBack}>Atrás</Link>)
                                                }

                                                errorText={errors.length > 0 ?
                                                    errors.map((error, index) => (
                                                        <React.Fragment key={index}>
                                                            {error}
                                                            <br /> {/* Use <br /> for line breaks within the Alert */}
                                                        </React.Fragment>
                                                    ))
                                                    : undefined}
                                            >
                                                <SpaceBetween direction="vertical" size="xs">
                                                    <SpaceBetween direction="horizontal" size="xs">
                                                        <Input
                                                            controlId='infoPassword1'
                                                            value={inputPassword1}
                                                            type='password'
                                                            onChange={handleInputPassword1}
                                                            ref={inputRef}
                                                            autoComplete="new-password"
                                                        />
                                                        {errors.length === 0 && inputPassword1.length > 0 ?
                                                            (<>
                                                                <Button iconName='check' variant="primary"></Button>
                                                            </>) : null
                                                        }
                                                    </SpaceBetween>
                                                </SpaceBetween>
                                            </FormField>
                                        )}
                                        {showNewPassword && (
                                            <FormField label="Confirmación"
                                            >

                                                <SpaceBetween direction="horizontal" size="xs">
                                                    <Input
                                                        controlId='infoPassword2'
                                                        value={inputPassword2}
                                                        type='password'
                                                        onChange={handleInputPassword2}
                                                        ref={inputRef}
                                                        autoComplete="new-password"
                                                    />
                                                    {errors.length === 0 && inputPassword1.length > 0 && inputPassword1 === inputPassword2 ?
                                                        (<>
                                                            <Button iconName='check' variant="primary"></Button>
                                                        </>) : null
                                                    }
                                                </SpaceBetween>
                                            </FormField>
                                        )}
                                        {showNewPassword && (
                                            <Button onClick={handleValidateNewPasword} disabled={isDisabledBtnMod} variant="primary" loading={loadingBtnNext} >Modificar</Button>

                                        )}
                                    </SpaceBetween>

                                </Container>
                            </SpaceBetween>

                        </Form>
                    </form>
                }
            />
        </>
    );
};

